export function getOrderRowsTotalValue (ordersRows, propertyName) {
  const value = ordersRows.reduce(function (accumulator, row) {
    const value = row[propertyName]
    return accumulator + value
  }, 0)
  return 1 * value
}
